"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentOutlineButton = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const BasicButton_1 = require("@jsonjoy.com/ui/lib/2-inline-block/BasicButton");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const Popup_1 = require("@jsonjoy.com/ui/lib/4-card/Popup");
const EmptyState_1 = require("@jsonjoy.com/ui/lib/4-card/EmptyState");
const EditorContextPopup_1 = require("./EditorContextPopup");
const ContextMenu_1 = require("@jsonjoy.com/ui/lib/4-card/ContextMenu");
const context_2 = require("../context");
const list_columns_reverse_1 = tslib_1.__importDefault(require("iconista/lib/react/bootstrap/list-columns-reverse"));
const Icon = (props) => React.createElement(list_columns_reverse_1.default, { width: 16, height: 16, ...props });
// const Icon = makeIcon({set: 'bootstrap', icon: 'card-heading', width: 16, height: 16});
const buttonLabelClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    ai: 'center',
    gap: '8px',
});
const emptyStateClass = (0, nano_theme_1.rule)({
    pd: '10px 12px 14px',
    fz: '12px',
    lh: '1.55',
});
const DocumentOutlineButton = ({ editor, contentWidth }) => {
    const styles = (0, context_1.useStyles)();
    const mutxt = (0, context_2.useMuTxt)();
    mutxt.contentVersion.use();
    const outline = mutxt.outline();
    const renderContext = () => outline.length ? (React.createElement(ContextMenu_1.ContextMenu, { inset: true, menu: {
            name: 'Table of contents',
            minWidth: Math.min(320, window.innerWidth - 32),
            children: mutxt.docMenu.outlineItems(),
        } })) : (React.createElement(EditorContextPopup_1.EditorContextPopup, { noMargin: true, title: 'Document contents', subtitle: outline.length
            ? `${outline.length} section${outline.length === 1 ? '' : 's'} from heading structure.`
            : 'Add headings to build a quick outline.' },
        React.createElement(EmptyState_1.EmptyState, { frame: true },
            React.createElement("div", { className: emptyStateClass, style: { color: styles.light ? styles.g(0.4) : styles.g(0.6) } }, "Use Heading 1, Heading 2, or Heading 3 blocks to populate the contents list."))));
    return (React.createElement(Popup_1.Popup, { renderContext: renderContext, tooltip: { renderTooltip: () => 'Table of contents', nowrap: true } },
        React.createElement(BasicButton_1.BasicButton, { width: 'auto', height: 32, compact: true, rounder: true, "aria-label": 'Open document table of contents' },
            React.createElement("span", { className: buttonLabelClass },
                React.createElement(Icon, null),
                React.createElement("span", null, "Go to")))));
};
exports.DocumentOutlineButton = DocumentOutlineButton;
